// Delegation survives Theme Editor section replacement. Native anchors work without JS.
if (!window.nrSpectrumAnchors) {
  window.nrSpectrumAnchors = true;
  document.addEventListener('click', event => {
    const link = event.target.closest('.nr-spectrum a[href^="#nr-spectrum-"]');
    if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    event.preventDefault();
    target.focus({preventScroll: true});
    target.scrollIntoView({behavior: 'instant', block: 'start'});
    history.replaceState(null, '', link.hash);
  });
}
